import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles, styled } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import List from '@material-ui/core/List';
import Badge from '@material-ui/core/Badge';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withRouter, Link } from 'react-router-dom';

import TopBar from './TopBar';
import COLORS from '../../styles/colors';
import db, {
	auth,
	createTimestamp,
	messaging,
	getFieldPath,
} from './../../firebase';
import { MIN_DESKTOP_WIDTH } from '../../constants';
import {
	FEATURED_LEFT_BAR_LINKS,
	COROPRATE_LEFT_BAR_LINKS,
	LEFT_BAR_LINKS,
} from '../../static-content';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const drawerWidth = 240;

const styles = theme => ({
	root: {
		display: 'flex',
	},
	block: {
		display: 'block',
	},
	appBar: {
		zIndex: theme.zIndex.drawer + 1,
		background: COLORS.white,
	},
	drawer: {
		width: drawerWidth,
		flexShrink: 0,
	},
	drawerPaper: {
		width: drawerWidth,
		paddingTop: 20,
		background: COLORS.greyFour,
	},
	content: {
		flexGrow: 1,
		padding: theme.spacing(3),
	},
	toolbar: theme.mixins.toolbar,
});

const StyledBadge = styled(Badge)(({ theme }) => ({
	'& .MuiBadge-badge': {
		right: -3,
		top: 7,
		backgroundColor: 'rgb(234, 94, 1)',
	},
}));

function Container(props) {
	const { classes, location } = props;
	const { pathname } = location;
	const [notificationCount, setChatNotication] = useState(0);
	const parentLink = props.history.location.pathname.split('/')[1];
	let LEFT_PANEL_LINKS;
	let userType =
		props.currentUser &&
		props.currentUser &&
		props.currentUser.user.type &&
		props.currentUser.user.type;
	if (userType && userType.includes('trainer')) {
		LEFT_PANEL_LINKS = LEFT_BAR_LINKS;
	}
	if (userType && userType.includes('brand')) {
		LEFT_PANEL_LINKS = FEATURED_LEFT_BAR_LINKS;
	}
	if (userType && userType.includes('corporate')) {
		LEFT_PANEL_LINKS = COROPRATE_LEFT_BAR_LINKS;
	}

	useEffect(() => {
		auth.onAuthStateChanged(authUser => {
			if (authUser) {
				db.collection('users')
					.doc(authUser.uid)
					.collection('chats')
					.orderBy('timestamp', 'desc')
					.onSnapshot({ includeMetadataChanges: true }, snap => {
						let count = 0;
						if (snap.docs && snap.docs.length > 0) {
							snap.docChanges().forEach(change => {
								const { unreadMessages } = change.doc.data();
								if (unreadMessages > 0) {
									count = count + 1;
								}
							});
						}
						setChatNotication(count);
					});
			}
		});
	}, []);

	

	return (
		<div className={(
			   pathname === '/social/mobile/posts') ?
			   classes.block : classes.root
			}>
			<CssBaseline />
			{(pathname !== '/assign/mobile/clients' &&
			  pathname !== '/social/mobile/posts')
			&& (
				<AppBar position="fixed" className={classes.appBar}>
					<TopBar
						currentUser={props.currentUser}
						pathname={pathname}
						logout={props.logout}
						history={props.history}
					/>
				</AppBar>
			)}
			{ parentLink !== 'chat' && 
			  parentLink !== 'social' && 
			  pathname !== '/assign/mobile/clients' &&
			  pathname !== '/social/mobile/posts'
			&& (
				<Drawer
					className={classes.drawer}
					variant="permanent"
					classes={{
						paper: classes.drawerPaper,
					}}
				>
					<div className={classes.toolbar} />
					{props.currentUser.isAuthenticated ? (
						<List>
							{LEFT_PANEL_LINKS &&
								LEFT_PANEL_LINKS.map((link, index) => {
									let linkColor =
										parentLink === link.text.toLowerCase() ||
										(link.text === 'Past Assignments' &&
											parentLink === 'assignments')
											? COLORS.orange
											: COLORS.black;

									if (parentLink === 'manageBrands' && link.text === 'Brands')
										linkColor = COLORS.orange;
									if (parentLink === 'manageNCEPTrainers' && link.text === 'NCEP Trainers')
										linkColor = COLORS.orange;
									if (parentLink === 'manageTrainers' && link.text === 'Trainers')
										linkColor = COLORS.orange;
									if (parentLink === 'stats' && link.text === 'NCEP Stats')
										linkColor = COLORS.orange;
									if (
										parentLink === 'managePushNotifications' &&
										link.text === 'Push Notifications'
									)
										linkColor = COLORS.orange;
									return (
										<Link to={link.route} key={index}>
											<ListItem
												button
												style={{
													marginBottom: link.break ? 20 : 0,
													paddingTop: 0,
													paddingBottom: 0,
												}}
											>
												<div style={{ marginLeft: 15 }}></div>

												{link.icon ? (
													<FontAwesomeIcon
														icon={link.icon}
														style={{
															color: linkColor,
															width: 20,
															position: 'relative',
															left: 0,
														}}
													/>
												) : (
													<div style={{ width: 20 }}></div>
												)}
												{link.text === 'Chat' && notificationCount > 0 ? (
													<StyledBadge
														variant="dot"
														badgeContent={notificationCount}
														color="secondary"
													>
														<ListItemText
															style={{ color: linkColor }}
															primary={link.text}
														/>
													</StyledBadge>
												) : (
													<ListItemText
														style={{ color: linkColor }}
														primary={link.text}
													/>
												)}
											</ListItem>
										</Link>
									);
								})}
						</List>
					) : (
						<Link
							to="signin"
							style={{
								textAlign: 'center',
							}}
						>
							Sign In
						</Link>
					)}
				</Drawer>
			)}
			{(parentLink !== 'chat' 
			  && parentLink !== 'social')
			? (
				<main className={
					pathname !== '/assign/mobile/clients' && 
					pathname !== '/social/mobile/posts' &&
			    	classes.content}>
					{pathname !== '/assign/mobile/clients' &&
					pathname !== '/social/mobile/posts' &&
					pathname !== '/social/mobile/intro'
					&& <div className={classes.toolbar} />}
					<div
						style={{
							padding: '10px',
							maxWidth: MIN_DESKTOP_WIDTH,
							margin: 'auto',
						}}
					>
						{props.children}
					</div>
				</main>
			) : (
				<div style={{ width: '100%', marginTop: pathname === '/social/mobile/posts' ? '0px' : '64px' } }>{props.children}</div>
			)}
		</div>
	);
}

Container.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(Container));



// WEBPACK FOOTER //
// ./src/components/nav/Container.js